export function init () {
	if ($('.has-video-iframe').length) {
		var browserWindow = $(window);

		browserWindow.on('resize', function() {
			$('.has-video-iframe').each(function() {
				var elm = $(this);
				var ratio = elm.data('iframe-ratio').split('_');

				var iframeWidth = elm.find('iframe').width();
				var iframeHeight = (iframeWidth / ratio[0]) * ratio[1];

				elm.find('iframe').height(iframeHeight);
			});
		});

		browserWindow.trigger('resize');
	}
}

init();
